module.exports = __webpack_public_path__ + "static/img/2.de0d481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/cpzl/2.jpg
// module id = xwNH
// module chunks = 0